<template>
  <v-row>
    <v-col cols="12">
      <!-- Start Tab Content  -->
      <div class="rn-testimonial-content">
        <v-row align="center">
          <v-col md="6" sm="12" cols="12" class="tesimonail-conent-inner">
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="group in testimonialContent" :key="group.id">
                <v-card flat v-for="(t, i) in group.content" :key="i">
                  <v-card-text>
                    <div class="inner">
                      <p>
                        {{ t.description }}
                      </p>
                    </div>
                    <div class="author-info">
                      <h6>
                        <span>{{ t.name }}</span> -
                        {{ t.designation }}
                      </h6>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
            <!-- End .v-tabs-items -->
          </v-col>
          <v-col md="6" sm="12" cols="12" class="mt_md--40 mt_sm--40">
            <v-tabs v-model="tab" centered hide-slider center-active>
              <v-tab v-for="item in tabItems" :key="item.id" :ripple="false">
                <div class="thumb">
                  <img :src="item.src" alt="testimonial image" />
                </div>
              </v-tab>
            </v-tabs>
            <!-- End .v-tabs -->
          </v-col>
        </v-row>
      </div>
      <!-- End .rn-testimonial-content -->
    </v-col>
  </v-row>
</template>

<script>
  export default {
    data() {
      return {
        tab: null,
        testimonialContent: [
          {
            id: 0,
            content: [
              {
                name: "Fernando Portugal",
                description:
                  "Gostaria de registrar meu agradecimento e elogio à equipe da CodeTime, especialmente ao Leonardo e à Maria, que têm se mostrado extremamente competentes, proativos e comprometidos com a excelência do serviço prestado. Desde o início do projeto, ambos demonstraram profissionalismo, cumprindo todos os prazos estipulados e entregando sempre mais do que o combinado.\n\nA ferramenta desenvolvida por eles não só atendeu nossas expectativas como vem sendo constantemente aprimorada com melhorias relevantes. Além disso, o custo-benefício é excelente e, sempre que surgem dúvidas ou ajustes necessários, o atendimento é rápido e resolutivo, algo raro e muito valorizado.\n\nEstou muito satisfeito com a parceria firmada até aqui e faço questão de reforçar meu desejo de perpetuar esse crescimento em conjunto, construindo resultados cada vez mais sólidos e inovadores.\n\nParabéns e obrigado por toda dedicação.",
                designation: "LLP Contabilidade - Itajaí/SC",
              },
            ],
          },
          {
            id: 1,
            content: [
              {
                name: "Leandro Nascimento",
                description: "Pessoal Passando aqui pra agradecer essa MÁQUINA DE DINHEIRO que vocês fizeram. Rodando liso demais, funcionando perfeitamente Obrigado mesmo!!",
                designation: "Análise de dados com IA - Jaboatão dos Guararapes/PE",
              },
            ],
          },
          {
            id: 2,
            content: [
              {
                name: "Reinaldo Carvalho",
                description:
                  "Temos a honra de trabalhar com a Codetime, um parceiro de desenvolvimento excepcional que combina expertise técnica, inovação e comprometimento em cada projeto. Sua capacidade de transformar nossas necessidades em soluções robustas e escaláveis tem sido fundamental para o sucesso do nosso sistema. Recomendamos sem reservas!",
                designation: "Gestor Top - Amargosa/BA",
              },
            ],
          },
          {
            id: 3,
            content: [
              {
                name: "Valdir Lázzari",
                description:
                  "No começo da Efficon era só uma ideia no papel, muita vontade de fazer diferente no canteiro e um frio na barriga. Eu sabia que ia precisar de um time que acreditasse comigo e ajudasse a transformar isso em realidade.\n\nFoi aí que entrou o pessoal da Codetime. Desde o primeiro contato, toparam o desafio, entenderam a essência do projeto e vieram junto, com muita parceria, escuta e dedicação. A cada nova etapa, eles ajudaram a transformar as ideias em algo funcional, com sugestões que fizeram toda diferença.\n\nHoje ver o sistema funcionando, sendo testado por parceiros e recebendo elogios, é um baita orgulho. Sei que isso só tá acontecendo porque tive gente comprometida e que comprou a visão lá do início. Gratidão demais por estarem nessa comigo!",
                designation: "Efficon - Camboriú/SC",
              },
            ],
          },
          {
            id: 4,
            content: [
              {
                name: "Mario Santos",
                description:
                  "Quando você decide construir uma empresa de base tecnológica, o time de desenvolvimento é o mais importante. Terceirizar exige extrema confiança, e a Code tem sido muito parceira nessa jornada.\n\nAlém disso, o time da Code se mostra adaptável às necessidades de ajustes finos e integrações com tecnologias novas. Isso faz toda diferença no nosso crescimento e reforça a confiança de que estamos juntos nessa caminhada.",
                designation: "Healthby AI - Barueri/SP",
              },
            ],
          },
          {
            id: 5,
            content: [
              {
                name: "Sabino Oliveira",
                description:
                  "Equipe excepcional! A Codetime conduziu todo o processo de desenvolvimento e publicação do nosso aplicativo nas lojas (App Store e Google Play) com extrema maestria. Passamos por fases de testes, homologação e ajustes finos, e eles lidaram com cada desafio técnico e exigência das plataformas com total transparência e eficiência. Entrega impecável!",
                designation: "Portal Do Cegonheiro - São Paulo/SP",
              },
            ],
          },
          // {
          //   id: 5,
          //   content: [
          //     {
          //       name: "JOHN SMITH",
          //       description:
          //         "Trecho clássico de Lorem Ipsum utilizado há séculos, aqui apenas como placeholder.",
          //       designation: "COO, AMERIMAR ENTERPRISES, INC.",
          //     },
          //   ],
          // },
          // {
          //   id: 6,
          //   content: [
          //     {
          //       name: "AMAR ORTHI",
          //       description:
          //         "Trecho de texto de exemplo utilizado por muitos anos, apenas para fins de visualização.",
          //       designation: "COO, AMERIMAR ENTERPRISES, INC.",
          //     },
          //   ],
          // },
          // {
          //   id: 7,
          //   content: [
          //     {
          //       name: "FATIMA MA",
          //       description:
          //         "Trecho padrão de Lorem Ipsum utilizado historicamente, exibido aqui como exemplo.",
          //       designation: "COO, AMERIMAR ENTERPRISES, INC.",
          //     },
          //   ],
          // },
          // {
          //   id: 8,
          //   content: [
          //     {
          //       name: "JON CUMMINS",
          //       description:
          //         "Texto ilustrativo tradicional, utilizado apenas como preenchimento visual.",
          //       designation: "COO, AMERIMAR ENTERPRISES, INC.",
          //     },
          //   ],
          // },
        ],

        tabItems: [
          {
            id: 0,
            src: require("../../assets/images/client/llp.webp"),
          },
          {
            id: 1,
            src: require("../../assets/images/client/person.jpg"),
          },
          {
            id: 2,
            src: require("../../assets/images/client/gestor-top.webp"),
          },
          {
            id: 3,
            src: require("../../assets/images/client/efficon.webp"),
          },
          {
            id: 4,
            src: require("../../assets/images/client/health.webp"),
          },
          {
            id: 5,
            src: require("../../assets/images/client/portalcegonheiro.webp"),
          },
          // {
          //   id: 5,
          //   src: require("../../assets/images/client/testimonial-5.webp"),
          // },
          // {
          //   id: 6,
          //   src: require("../../assets/images/client/testimonial-9.webp"),
          // },
          // {
          //   id: 7,
          //   src: require("../../assets/images/client/testimonial-7.webp"),
          // },
          // {
          //   id: 8,
          //   src: require("../../assets/images/client/testimonial-8.webp"),
          // },
        ],
      };
    },
    methods: {},
  };
</script>

<style scoped>
.tesimonail-conent-inner .inner p {
  font-size: 15px !important;
  line-height: 24px !important;
}
.tesimonail-conent-inner .author-info h6 {
  font-size: 13px !important;
  line-height: 20px !important;
}
.tesimonail-conent-inner .rn-btn.btn-small {
  padding: 4px 10px;
  font-size: 11px;
}
@media (max-width: 600px) {
  .tesimonail-conent-inner .inner p { font-size: 14px !important; line-height: 22px !important; }
  .tesimonail-conent-inner .author-info h6 { font-size: 12px !important; line-height: 18px !important; }
}
</style>
